/**
 * External dependencies
 */
import React from "react";
import classnames from "classnames";
import { Box } from "@towersystems/towersystems-design-system";

/**
 * Internal dependencies
 */
import DropdownLink from "components/dropdown-link";

const ReportActions = ({ className, actions, name }) => {
  const classes = classnames("report__report-actions");

  return (
    <Box className={classes}>
      <DropdownLink title="Actions" items={actions} />
    </Box>
  );
};

export default ReportActions;
